export const appRoute = {
  home : "home",
  validate: "validate",
  biDashboard: "bi-dashboard",
};
